/**
 * 
    - VisibilityManagement
    - AIReview
    - BusinessPartner
    - Administrator
    - UserManagement
    - Impersonate
    - FreeEvaluationMessageAdmin
    - ReportAccess
    - HR
 */
export enum UserRoleEnum {
    VisibilityManagement = "VisibilityManagement",
    AIReview = "AI-Review",
    BusinessPartner = "BusinessPartner",
    Administrator = "Administrator",
    UserManagement = "UserManagement",
    Impersonate = "Impersonate",
    FreeEvaluationMessageAdmin = "FreeEvaluation.Message.Admin",
    ReportAccess = "ReportAccess",
    HR = "HR",
    CalibrationVisibility = "CalibrationVisibility",
}